import type { Mission } from '../missions.ts'

export const cbpOfo: Mission = {
  id: "cbp-ofo",
  name: "Office of Field Operations",
  short: "OFO",
  call: "Field Operations",
  kind: "subagency",
  parent: "cbp",
  url: "https://www.cbp.gov/border-security/ports-entry",
  palette: {
    primary: "#223f74",
    secondary: "#0f1013",
    accent: "#b5081b",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:CBP-OFO_Patch.JPG",
  },
  motif: "key",
  mission: {
    text: "Safeguard lawful U.S. travel, trade and agriculture to protect national and economic security.",
    url: "https://www.cbp.gov/border-security/ports-entry/field-operations",
  },
  fact: {
    text: "OFO is the largest component in CBP, working at 19 field offices, 328 ports of entry and 113 international locations in over 48 countries.",
    url: "https://www.cbp.gov/border-security/ports-entry/field-operations",
  },
  seal: {
    file: "public/seals/cbp-ofo.png",
    source: "https://commons.wikimedia.org/wiki/File:CBP-OFO_Patch.JPG",
  },
  identifier: {
    about: "https://www.cbp.gov/about",
    accessibility: "https://www.cbp.gov/site-policy-notices/accessibility",
    foia: "https://www.cbp.gov/site-policy-notices/foia",
    noFear: "https://www.cbp.gov/about/eeo/no-fear-act",
    oig: "https://www.oig.dhs.gov/",
    performance: "https://www.cbp.gov/document/publications/cbp-strategy-2021-2026",
    privacy: "https://www.cbp.gov/site-policy-notices/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/cbp-ofo-vehicle-inspection.jpg",
        small: "/media/cbp-ofo-vehicle-inspection-sm.jpg",
        alt: "A CBP officer in a high-visibility vest holds a handheld density scanner against the trailer of a tractor-trailer at a port of entry inspection station.",
        title: "CBP officer inspecting a vehicle at a port of entry, September 14, 2010",
        creator: "Donna Burton, CBP Photography, U.S. Customs and Border Protection",
        source: "https://commons.wikimedia.org/wiki/File:CBP_Port_of_Entry_Inspection_Station_(5764596479).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
